import { Component, Input } from '@angular/core';
import { IOrganizationWhiteLabel } from '../../../models/white-label.model';

@Component({
  selector: 'irembogov-white-label-theme-main-page-layout',
  templateUrl: './white-label-theme-main-page-layout.component.html',
  styleUrls: ['./white-label-theme-main-page-layout.component.scss'],
})
export class WhiteLabelThemeMainPageLayoutComponent {
  @Input() portalConfig: IOrganizationWhiteLabel | undefined = undefined;
}
